import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import './Header.css';

const Header = ({ isAuthenticated, setIsAuthenticated }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <header className="header">
      <Link to="/" className="wordmark">
        Colin Stebelski
      </Link>
      <nav className="navigation" aria-label="Primary">
        <ul>
          <li><NavLink to="/projects">Projects</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
          {isAuthenticated && (
            <>
              <li><NavLink to="/videos">Family videos</NavLink></li>
              <li>
                <button type="button" onClick={handleLogout} className="logout-btn">
                  Log out
                </button>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
